// extracted by mini-css-extract-plugin
module.exports = {"headlineContainer":"_cVA3_8Sr","container":"_8pVaIZeQ","content":"_fSIydwx8","radio":"_-b6vB-LX","headline":"_UnQuhucj","badge":"_9lfAjr3Q"};